
import React from 'react';
import { Link } from 'react-router-dom';

const Introduction: React.FC = () => {
  return (
    <>
      <p className="mb-6 text-gray-700 leading-relaxed">
        As your business evolves, so do your technology needs. What works for a startup with five employees won't necessarily serve a growing mid-sized business with multiple locations. Understanding which IT support model aligns with your current growth stage can save you from costly mismatches while positioning your organization for sustainable expansion.
      </p>
      
      <p className="mb-6 text-gray-700 leading-relaxed">
        This guide explores how to match your business growth stage with the right IT support approach, helping you make strategic decisions about your <Link to="/services/project-consulting" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue underline">technology management</Link>.
      </p>

      <div className="mb-8 bg-itmgmt-light-blue/10 p-5 rounded-lg border-l-4 border-itmgmt-medium-blue">
        <h3 className="text-xl font-semibold mb-3 text-itmgmt-dark-blue">Quick Navigation</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
          <Link to="#support-models" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">IT Support Models Explained</Link>
          <Link to="#growth-stages" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Matching Models to Growth Stages</Link>
          <Link to="#transition-indicators" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">When to Change Your Support Model</Link>
          <Link to="#successful-transition" className="text-itmgmt-medium-blue hover:text-itmgmt-bright-blue">Making a Successful Transition</Link>
        </div>
      </div>
    </>
  );
};

export default Introduction;
